import { render, staticRenderFns } from "./merchantNetInfo.vue?vue&type=template&id=16189497&scoped=true&"
import script from "./merchantNetInfo.vue?vue&type=script&lang=js&"
export * from "./merchantNetInfo.vue?vue&type=script&lang=js&"
import style0 from "./merchantNetInfo.vue?vue&type=style&index=0&id=16189497&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16189497",
  null
  
)

export default component.exports